import * as bootstrap from 'bootstrap';
import { formatDate2, formatYear } from '../../../../format/formatDate';
import Avatar from '../../../compoment/Avatar';
import '../css/member.css';
import { useEffect } from 'react';

const Member = ({ user, isOpen, toggleOpen }) => {
  const getAttributeValues = (keyword, attributeValues) => {
    const isValue = attributeValues.find(
      (item) => item.userAttribute.code === keyword
    );
    return isValue?.value ? (
      isValue.value
    ) : (
      <span className="unknown-value">(chưa xác định)</span>
    );
  };

  const getTextValues = (value) => {
    return value ? (
      value
    ) : (
      <span className="unknown-value">(chưa xác định)</span>
    );
  };

  const getGender = (gender) => {
    switch (gender) {
      case 'male':
        return 'Nam';
      case 'female':
        return 'Nữ';
      default:
        return 'Khác';
    }
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    );

    // cleanup khi unmount
    return () => {
      tooltipList.forEach((t) => t.dispose());
    };
  }, []);

  return (
    <div className="member-card">
      {/* Header với avatar và thông tin chính */}
      <div className="member-header">
        <div className="member-avatar">
          {user.avatar_url ? (
            <img src={user.avatar_url} alt={user.full_name} />
          ) : (
            <Avatar fullName={user.full_name} isCircle={true} />
          )}
        </div>

        <div className="member-basic-info">
          <div className="member-name-section">
            <h4 className="member-name">{user.full_name}</h4>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '1rem',
              }}
            >
              <span className="member-major">
                Ngành: {getAttributeValues('nganh', user.attributeValues)}
              </span>

              <span className="member-major">
                Công ty:{' '}
                {getAttributeValues('noi-lam-viec', user.attributeValues)}
              </span>

              <span className="member-major">
                Lĩnh vực:{' '}
                {getAttributeValues('linh-vuc-hoat-dong', user.attributeValues)}
              </span>
            </div>
          </div>

          {/* Thông tin cơ bản trong grid */}
          <div className="member-quick-info">
            <div className="info-item">
              <div
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="custom-tooltip"
                data-bs-title="Lớp học"
              >
                <img
                  src="/images/icons/presentation.png"
                  alt="Lớp"
                  style={{ marginRight: '0.5rem' }}
                />
                <span>{getAttributeValues('lop', user.attributeValues)}</span>
              </div>
            </div>

            <div className="info-item">
              <div
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="custom-tooltip"
                data-bs-title="Năm sinh"
              >
                <img
                  src="/images/icons/birthday.png"
                  alt="Năm sinh"
                  style={{ marginRight: '0.5rem' }}
                />
                <span>{formatYear(user.date_of_birth)}</span>
              </div>
            </div>

            <div className="info-item">
              <div
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="custom-tooltip"
                data-bs-title="Số điện thoại"
              >
                <img
                  src="/images/icons/phone.svg"
                  alt="Số điện thoại"
                  style={{ marginRight: '0.5rem' }}
                />
                <span className={`${!user.phone_number && 'unknown-value'}`}>
                  {user.phone_number || '(chưa xác định)'}
                </span>
              </div>
            </div>
            <div className="info-item">
              <div
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="custom-tooltip"
                data-bs-title="Địa chỉ"
              >
                <img
                  src="/images/icons/location-orange.png"
                  alt="Địa chỉ"
                  style={{ marginRight: '0.5rem' }}
                />
                <span className={`${!user.address && 'unknown-value'}`}>
                  {user.address || '(chưa xác định)'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Nút xem chi tiết */}
        <div className="member-actions">
          <button className="toggle-details-btn" onClick={toggleOpen}>
            <span className="btn-text">Xem thêm</span>
            <i
              className={`fas fa-chevron-down ${isOpen ? 'rotate-180' : ''}`}
            ></i>
          </button>
        </div>
      </div>

      {/* Chi tiết mở rộng */}
      <div className={`member-details ${isOpen ? 'show' : ''}`}>
        <div className="details-content">
          <h5 className="details-title">Thông tin chi tiết</h5>

          {/* Thông tin cá nhân */}
          <div className="details-section">
            <h6 className="section-title">Thông tin cá nhân</h6>
            <div className="details-grid">
              <div className="detail-item">
                <span className="label">MSSV:</span>
                <span className="value">{getTextValues(user.code)}</span>
              </div>
              <div className="detail-item">
                <span className="label">Họ và tên:</span>
                <span className="value">{user.full_name}</span>
              </div>
              <div className="detail-item">
                <span className="label">Ngày sinh:</span>
                <span className="value">{formatDate2(user.date_of_birth)}</span>
              </div>
              <div className="detail-item">
                <span className="label">Giới tính:</span>
                <span className="value">{getGender(user.gender)}</span>
              </div>
              <div className="detail-item">
                <span className="label">Email:</span>
                <span className="value">{getTextValues(user.email)}</span>
              </div>
              <div className="detail-item">
                <span className="label">Số điện thoại:</span>
                <span className="value">
                  {getTextValues(user.phone_number)}
                </span>
              </div>
              <div className="detail-item full-width">
                <span className="label">Địa chỉ nơi ở:</span>
                <span className="value">{getTextValues(user.address)}</span>
              </div>
            </div>
          </div>

          {/* Thông tin học tập */}
          <div className="details-section">
            <h6 className="section-title">Thông tin học tập</h6>
            <div className="details-grid">
              <div className="detail-item">
                <span className="label">Lớp:</span>
                <span className="value">
                  {getAttributeValues('lop', user.attributeValues)}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Ngành:</span>
                <span className="value">
                  {getAttributeValues('nganh', user.attributeValues)}
                </span>
              </div>
              <div className="detail-item full-width">
                <span className="label">Đơn vị:</span>
                <span className="value">
                  {getAttributeValues('don-vi', user.attributeValues)}
                </span>
              </div>
            </div>
          </div>

          {/* Thông tin công việc */}
          <div className="details-section">
            <h6 className="section-title">Thông tin công việc</h6>
            <div className="details-grid">
              <div className="detail-item full-width">
                <span className="label">Nơi làm việc:</span>
                <span className="value">
                  {getAttributeValues('noi-lam-viec', user.attributeValues)}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Chức vụ hiện tại:</span>
                <span className="value">
                  {getAttributeValues('chuc-vu', user.attributeValues)}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Lĩnh vực hoạt động:</span>
                <span className="value">
                  {getAttributeValues(
                    'linh-vuc-hoat-dong',
                    user.attributeValues
                  )}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Vị trí trong Hội:</span>
                <span className="value">
                  {getAttributeValues('vi-tri-trong-hoi', user.attributeValues)}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Địa điểm làm việc:</span>
                <span className="value">
                  {getAttributeValues(
                    'dia-diem-lam-viec',
                    user.attributeValues
                  )}
                </span>
              </div>
            </div>
          </div>

          {/* Thông tin gia đình */}
          <div className="details-section">
            <h6 className="section-title">Thông tin gia đình</h6>
            <div className="details-grid">
              <div className="detail-item">
                <span className="label">Họ tên Vợ/Chồng:</span>
                <span className="value">
                  {getAttributeValues('ho-ten-vo-chong', user.attributeValues)}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Nơi làm việc của Vợ/Chồng:</span>
                <span className="value">
                  {getAttributeValues(
                    'noi-lam-viec-vo-chong',
                    user.attributeValues
                  )}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Họ tên Con:</span>
                <span className="value">
                  {getAttributeValues('ho-ten-con', user.attributeValues)}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Nơi làm việc/học tập của Con:</span>
                <span className="value">
                  {getAttributeValues('noi-lam-viec-con', user.attributeValues)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Member;
